import { Button } from "antd";
import React from "react";
import starsicon from "../../../images/stars.svg";
import whitearrowicon from "../../../images/whitearrow.svg";


interface FiltersAISearchInputProps {
    AIQuery: string;
    setAIQuery: (query: string) => void;
    loading: boolean;
    onSearchQueryClick: () => void;
}

const FiltersAISearchInput: React.FC<FiltersAISearchInputProps> = ({
    AIQuery,
    setAIQuery,
    loading,
    onSearchQueryClick
}) => {
    return (
        <div className="w-full relative">
            <textarea
                placeholder="Edit your query"
                className="w-full shadow-sm resize-none rounded-md outline-none py-2.5 px-3.5 pl-8 text-sm border border-main-border"
                rows={4}
                value={AIQuery}
                onChange={(e) => setAIQuery(e.target.value)}
            ></textarea>
            <img className="absolute top-2.5 left-2.5" src={starsicon} alt="Stars Icon" />
            <Button
                disabled={AIQuery.length === 0}
                loading={loading}
                icon={<img className="w-5 h-5" src={whitearrowicon} alt="Search" />}
                onClick={onSearchQueryClick}
                className="bg-primary w-11 h-9 flex justify-center items-center rounded-md absolute bottom-3 right-2.5 drop-shadow-button-4xl border border-[#FFFFFF1F]"
            />
        </div>
    );
};

export default FiltersAISearchInput;